import React, {useEffect, useState} from "react";
import "../../../../../Assets/Styles/Switch.scss";

const Switch = (props) => {
  const [IsChecked, setIsChecked] = useState(false)

  useEffect(() => {
    if (props.IsDisabled) {
      document
        .getElementById(props.Id + "switch-wrapper")
        .classList.add("disabled-switch");
    }
    if (props.ClassName) {
      document
        .getElementById(props.Id + "switch-wrapper")
        .classList.add(props.ClassName);
    }
  }, []);

  const switchState = () => {
    if (
      document.getElementById(props.Id + "-switch-holder").classList.length > 1
    ) {
      document
        .getElementById(props.Id + "-switch-holder")
        .classList.remove("off");
    } else {
      document.getElementById(props.Id + "-switch-holder").classList.add("off");
    }
    setTimeout(() => {
      props.ChangeEvent();
    }, 400);
  };

  const handleSwitchIcon = () => {
    document.getElementById(props.Id + "-switch-holder") &&
    document.getElementById(props.Id + "-switch-holder").classList
        .length === 1 ? setIsChecked(true) : setIsChecked(false)
  }

  useEffect(() => {
    // Select the node that will be observed for mutations
    const targetNode = document.getElementById(props.Id + "-switch-holder");

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver((e) => {
      if (e[0]?.target.classList.contains("switch-holder")) {
        setTimeout(() => {
          setIsChecked(e[0]?.target.classList.length === 1)
        }, 400)
      }
    });

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    handleSwitchIcon()
  }, [])

  return (
    <React.Fragment>
      <label id={props.Id + "switch-wrapper"} className="cx-simple-text-input">
        {props.IsActive ? (
          <div
            id={props.Id + "-switch-holder"}
            onClick={() => switchState()}
            className="switch-holder"
          >
            <span className="switch-border"></span>
            <span id="background-animator"></span>
            <section
              id={props.Id + "-switch-indicator"}
              className="switch-indicator"
            >
              <i className={IsChecked ? 'feather-check' : 'feather-minus'}/>
            </section>
          </div>
        ) : (
          <div
            id={props.Id + "-switch-holder"}
            onClick={() => switchState()}
            className="switch-holder off"
          >
            <span className="switch-border"></span>
            <span id="background-animator"></span>
            <section
              id={props.Id + "-switch-indicator"}
              className="switch-indicator"
            >
              <i className={IsChecked ? 'feather-check' : 'feather-minus'}/>
            </section>
          </div>
        )}
      </label>
    </React.Fragment>
  );
};
export default Switch;
